// removed by extract-text-webpack-plugin
module.exports = {"campaignEnterMobileInputContainer":"campaignEnterMobileInputContainer__2E7uq","campaignEnterInputBoxMobile":"campaignEnterInputBoxMobile__LUbaj","campaignEnterMobileSubmitButton":"campaignEnterMobileSubmitButton__1yfPv","mobileNoPrefix":"mobileNoPrefix__1PYLq","otpText":"otpText__22ISS"};


//////////////////
// WEBPACK FOOTER
// ./routes/campaign-fast-feature/components/mobile-input/style.css
// module id = 3m/+
// module chunks = 446